import { formatLocation } from "@/utils/text";

const MAX_LANES = 2;

const laneOf = (item) => {
  const stops = (item.loadBoardItem || item).itineraryStops ?? [];
  if (stops.length === 0) return null;
  const first = stops[0];
  const last = stops[stops.length - 1];
  const origin = formatLocation(first.stopCity, first.stopState);
  const destination = formatLocation(last.stopCity, last.stopState);
  if (!origin || !destination) return null;
  return `${origin} → ${destination}`;
};

export const buildNewLoadsNotification = (truckName, loads) => {
  const count = loads.length;
  const countLabel = count === 1 ? "1 new load" : `${count} new loads`;
  const title = truckName ? `${countLabel} · ${truckName}` : countLabel;

  const lanes = loads.map(laneOf).filter(Boolean);
  const lines = lanes.slice(0, MAX_LANES);
  const hiddenCount = count - lines.length;
  if (hiddenCount > 0 && lines.length > 0) lines.push(`+${hiddenCount} more`);

  return { title, body: lines.join("\n") };
};
